<script lang="ts">
	import { createEventDispatcher, onDestroy } from "svelte";
	import { Button, Col, FormGroup, Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Popover, Row } from "sveltestrap";
    import type { AppFileDto } from "../global";
    import { emailAttachmentService, emailLogService, emailService } from "../services";
    import { verfEmail } from "../services/Functions";
    import { success } from "../../public/my-theme";
    import { EmailLog } from "../Model/EmailLog";
    import { v4 as uuidv4 } from 'uuid';
    import { EmailAttachment } from "../Model/EmailAttachment";

	const dispatch = createEventDispatcher();

	let size = 'lg';
	let open = false;
	const delay = (ms: any | undefined) => new Promise(res => setTimeout(res, ms));

	export let files: AppFileDto[] = null;

    let filesToSend: string[] = [];
    let destinataries: {"Email": string}[] = [];
    let copies: {"Email": string}[] = [];
    let hiddenCoppies: {"Email": string}[] = [];
    let destinatary: string;
    let copy: string;
    let hiddenCopy: string;
    let subject: string;
    let content: string;
    let badEmail: boolean = true;
    let badCopyEmail: boolean = true;
    let badHiddenCopyEmail: boolean = true;

    

	$: open = !!files; 
    $: if(!open) {
        filesToSend = [];
        destinataries = [];
        copies = [];
        hiddenCoppies = [];
        destinatary = null;
        copy = null;
        hiddenCopy = null;
        subject = null;
        content = null;
        badEmail = true;
        badCopyEmail = true;
        badHiddenCopyEmail = true;
    }

	const toggle = () => {
	  size = 'lg';
	  open = !open;
	};

    function addDestinatary(type: string) {
        if(type == 'destinatary') {
            if(badEmail) {
                destinataries.push({"Email": destinatary});

                destinatary = null;

                destinataries = destinataries;
            } else {
                return;
            }
        } 
        
        if(type == 'copy') {
            if(badCopyEmail) {
                copies.push({"Email": copy});

                copy = null;

                copies = copies;
            }else {
                return;
            }
        } 
        
        if (type == 'hiddenCopy') {
            if(badHiddenCopyEmail) {
                hiddenCoppies.push({"Email": hiddenCopy});

                hiddenCopy = null;

                hiddenCoppies = hiddenCoppies;
            }else {
                return;
            }
        }
    }

    function deleteDestinatary(email: string, type: string) {
        if(type == 'destinatary') {
            let newDestinataries = destinataries.filter((newDestinatary) => {
                return newDestinatary.Email != email;
            })

            destinataries = newDestinataries;
        } else if(type == 'copy') {
            let newCopies = copies.filter((newCopy) => {
                return newCopy.Email != email;
            })

            copies = newCopies;
        } else if (type == 'hiddenCopy') {
            let newHiddenCopies = hiddenCoppies.filter((newHiddenCopy) => {
                return newHiddenCopy.Email != email;
            })

            hiddenCoppies = newHiddenCopies;
        }
    }

    async function sendEmail() {
        let mail = {
            destinataries: destinataries,
            cc: copies,
            bcc: hiddenCoppies,
            subject: subject,
            content: content,
            files: filesToSend
        }
        const res = await emailService.sendMail(mail);

        if(res) {
            let emailLog = new EmailLog({
                id: uuidv4(),
                destinatary: JSON.stringify(destinataries),
                cc: JSON.stringify(copies),
                bcc: JSON.stringify(hiddenCoppies),
                subject: subject,
                content: content,
                date_created: new Date()
            })

            const res = await emailLogService.insertLog(emailLog);

            if(res) {
                filesToSend.forEach(async (file) => {
                    let emailAttachment =  new EmailAttachment({
                        id: uuidv4(),
                        file_id: file,
                        email_log_id: emailLog.id,
                        date_created: new Date()
                    })

                    await emailAttachmentService.insertAttachment(emailAttachment);
                })

                open = !open;
                success('Se ha enviado el correo con éxito.')
            }
            
        }
    }

</script>
  
<Modal isOpen={open} {toggle} {size}>
    <ModalHeader {toggle}>Envío de correo</ModalHeader>
    <ModalBody>
        <FormGroup>
            <Label for="exampleEmail">Asunto</Label>
            <Input
                type="text"
                bind:value={subject}
            />
        </FormGroup>
        <Row>
            <Label for="exampleEmail">Destinatarios</Label>
            <Col xs='6'>
                <div class="input-group">
                    <Input
                        type="text"
                        bind:value={destinatary}
                        on:input={() => {badEmail = verfEmail(destinatary)}}
                    />
                    <button
                        class="btn btn-secondary"
                        type="button"
                        on:click={() => addDestinatary('destinatary')}
                    >
                        <Icon name="plus" />
                    </button>
                </div>
                {#if !badEmail}
                    <span class='text-danger' style="font-size: 13px">El email no sigue con el formato ejemplo@correo.com</span>
                {/if}
                <FormGroup>
                    {#if destinataries.length < 1}
                        <p class='fw-bold mt-3'>No hay destinatarios asignados</p>
                    {:else}
                        {#each destinataries as destinatary}
                            <div class='p-2 rounded-3 d-flex justify-content-between align-items-center w-100'>
                                <span >{destinatary.Email}</span>
                                <Button color='danger' on:click={() => deleteDestinatary(destinatary.Email, 'destinatary')}><Icon name='x'/></Button>
                            </div>
                            <hr>
                        {/each}
                    {/if}
                    
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col xs='6'>
                <Label for="exampleEmail">Copia</Label>
                <div class="input-group">
                    <Input
                        type="text"
                        bind:value={copy}
                        on:input={() => {badCopyEmail = verfEmail(copy)}}
                    />
                    <button
                        class="btn btn-secondary"
                        type="button"
                        on:click={() => addDestinatary('copy')}
                    >
                        <Icon name="plus" />
                    </button>
                </div>
                {#if !badCopyEmail}
                    <span class='text-danger' style="font-size: 13px">El email no sigue con el formato ejemplo@correo.com</span>
                {/if}
                <FormGroup>
                    {#if copies.length < 1}
                        <p class='fw-bold mt-3'>No hay destinatarios asignados</p>
                    {:else}
                        {#each copies as copy}
                            <div class='p-2 rounded-3 d-flex justify-content-between align-items-center w-100'>
                                <span >{copy.Email}</span>
                                <Button color='danger' on:click={() => deleteDestinatary(copy.Email, 'copy')}><Icon name='x'/></Button>
                            </div>
                            <hr>
                        {/each}
                    {/if}
                    
                </FormGroup>
            </Col>
            <Col xs='6'>
                <Label for="exampleEmail">Copia oculta</Label>
                <div class="input-group">
                    <Input
                        type="text"
                        bind:value={hiddenCopy}
                        on:input={() => {badHiddenCopyEmail = verfEmail(hiddenCopy)}}
                    />
                    <button
                        class="btn btn-secondary"
                        type="button"
                        on:click={() => addDestinatary('hiddenCopy')}
                    >
                        <Icon name="plus" />
                    </button>
                </div>
                {#if !badHiddenCopyEmail}
                    <span class='text-danger' style="font-size: 13px">El email no sigue con el formato ejemplo@correo.com</span>
                {/if}
                <FormGroup>
                    {#if hiddenCoppies.length < 1}
                        <p class='fw-bold mt-3'>No hay destinatarios asignados</p>
                    {:else}
                        {#each hiddenCoppies as hiddenCopy}
                            <div class='p-2 rounded-3 d-flex justify-content-between align-items-center w-100'>
                                <span >{hiddenCopy.Email}</span>
                                <Button color='danger' on:click={() => deleteDestinatary(hiddenCopy.Email, 'hiddenCopy')}><Icon name='x'/></Button>
                            </div>
                            <hr>
                        {/each}
                    {/if}
                    
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <FormGroup>
                <Label for="exampleEmail">Contenido del correo</Label>
                <Input
                    type="textarea"
                    rows={6}
                    bind:value={content}
                />
            </FormGroup>
        </Row>
        <Row>
            <Col>
                <Label>Seleccione los ficheros que desea enviar:</Label>
                {#if files.length > 0}
                    {#each files as file} 
                        <FormGroup>
                            <Input type="checkbox" label={file.name} on:change={() => {filesToSend.push(file.id)}} />
                        </FormGroup>
                    {/each}
                {:else}
                    <p>No hay ficheros para enviar</p>
                {/if}
            </Col>
        </Row>
    </ModalBody>
    <ModalFooter>
        <Button color='success' on:click={sendEmail}>Enviar</Button>
    </ModalFooter>
</Modal>